import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem } from '@mui/material'
import { findCode, printVariable } from '@util/helper'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import { useMediaQuery, useTheme } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment, useEffect, useState, useRef } from 'react'
import moment from 'moment'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import ConfirmDialog from '@components/ConfirmDialog'
import { Grid } from '@mui/material/'
import TabContext from '@mui/lab/TabContext'
import Box from '@mui/material/Box'
import TabList from '@mui/lab/TabList'
import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import ManagerRegiPartAgency from '@pages/manager/manager-regi.part.agency'
import { useLocation } from 'react-router-dom'

const TeacherRegiPartName = ({ record, open, onClose, reload }) => {
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const [file, set_file] = React.useState(null)
  // const [studentList, set_studentList] = React.useState([])
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [student, set_student] = React.useState(null)

  // redux
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [tabValue, set_tabValue] = React.useState('1')
  const [selectedOption, set_selectedOption] = React.useState('')
  // redux
  const codes = useSelector((state) => state.codeReducer)
  const offCodes = codes.filter(r => r.codeGroupId === 'SA29')
  
  const location = useLocation()
  const [curLocation, set_curLocation] = useState(location)
  const [loaded, set_loaded] = useState(false)

  const buttonRef = useRef(null)
  const recordRef = useRef(null)
  const offCodeRef = useRef(null)
  const [currentOffCode, set_currentOffCode] = useState('')

  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
  }
  const handleSelectChange = (event) => {
    set_selectedOption(event.target.value)
  }

  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    } else {
      onClose()
    }
  }

  const onLoad = async () => {}

  React.useEffect(() => {
    if (open) {
      onLoad()
    }
  }, [open])

  // NameList Tab
  const NameList = () => {
    const fields = [
      { field: 'id', placeholder: '', type: 'text', value: -1, visible: false, canSrch: false, selList: [] },
      { field: 'indexing', placeholder: 'No.', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
      { field: 'name', placeholder: '이름', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
      { field: 'schoolId', placeholder: '학교명', type: 'auto', value: '', visible: false, canSrch: true, selList: [] },
      { field: 'grade', placeholder: '학년', type: 'number', value: '', visible: true, canSrch: true, selList: [] },
      { field: 'className', placeholder: '반', type: 'text', value: '', visible: true, canSrch: true, selList: [] },
      { field: 'classNum', placeholder: '번호', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
      { field: 'remark', placeholder: '번호', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
      {
        field: 'gdnPhone',
        placeholder: '보호자 전화 번호',
        type: 'number',
        value: '',
        visible: true,
        canSrch: false,
        selList: [],
      },
    ]

    const agencyHandler = useState(false)
    const [studentList, set_studentList] = React.useState([])
    const [snapMap, set_snapMap] = useState({})
    const studentRef = useRef()

    const fetchRegis = async () => {
      const url = `/regi/lecture`
      const params = { lectureId: record.id, statCode: 'S001' }
      const resp = await WebService.get(url, params)
      if (resp.repCode === 'ack') {
        const repMessage = JSON.parse(resp.repMessage)
        const records = JSON.parse(repMessage.records)
        return records
      } else {
        openSnackbar(resp.repMessage)
      }
    }

    const fetchSnaps = async () => {
      console.log('fetchSnaps...')
      const url = `/regi/snap/cur/lecture/${record.id}`
      const resp = await WebService.get(url)
      if (resp.repCode !== 'ack') {
        openSnackbar(resp.repMessage)
        return
      }
      const repMessage = JSON.parse(resp.repMessage)
      return JSON.parse(repMessage.snapMap)
    }

    const onLoadNameList = async () => {
      const snapMap = await fetchSnaps()
      snapMap?.current?.forEach((d, i) => {
        let codeName = findCode(codes, 'SA29', d.offCode)?.name
        d.offCodeName = codeName
        if(d.prevYn === 'Y') {
          d.name = `${d.name}(기)`
        }
      })
      set_snapMap(snapMap)
      if (selectedOption === '') {
        set_selectedOption('current')
      }
    }

    const onRegiCancel = async (studentId) => {
      const url = `/regi/cancel/${schola.id}/${record.id}/${studentId}`
      const resp = await WebService.post(url)
      if (resp.repCode === 'ack') {
        openSnackbar('수강취소 되었습니다.')
        const idx = studentList.findIndex((r) => r.id === studentId)
        if (idx >= 0) {
          studentList.splice(idx, 1)
          set_studentList(studentList)
        }
        reload()
      } else {
        openSnackbar(resp.repMessage)
      }
    }

     const onChangeOffCode = async (studentId, offCode) => {
      const url = `/regi/change/offcode/${schola.id}/${record.id}/${studentId}/${offCode}`
      const resp = await WebService.post(url)
      if (resp.repCode === 'ack') {
        openSnackbar('처리되었습니다.')
        const newSnapMap = {...snapMap}
        const found = newSnapMap.current.find(r => r.id === studentId)
        if(found) {
          found.offCode = offCode
          set_snapMap(newSnapMap)
        }
        // reload()
      } else {
        openSnackbar(resp.repMessage)
      }
    }

    useEffect(() => {
      onLoadNameList()
      return () => {
        console.log('returning .....')
      }
    }, [])

    return (
      <Fragment>
        <ConfirmDialog
            btn={<Button ref={buttonRef} color={'error'} style={{display:'none'}}></Button>}
            title={'주의'}
            content={() => {
              let offCodeName = findCode(codes, 'SA29', offCodeRef.current)?.name?? ''
              return `${recordRef.current?.name?? ''} 학생의 귀가방법을 ${offCodeName} (으)로 변경하시겠습니까?`
            }}
            preHandle={ async () => {
              return true
            }}
            perform={() => {
              onChangeOffCode(recordRef.current.id, offCodeRef.current) 
            }}
        />  

        {agencyHandler[0] ? (
          <ManagerRegiPartAgency
            record={record}
            student={studentRef.current}
            dialogHandler={agencyHandler}
            callback={() => {
              onLoadNameList()
              reload()
            }}
          />
        ) : null}
        <MUITable>
          <MyTableHead>
            <TableRow>
              {fields.map((col, index) => {
                if (col.visible) {
                  return (
                    <TableCell key={index} size="small">
                      {col.placeholder}
                    </TableCell>
                  )
                }
              })}

			        {selectedOption === 'current' ? <TableCell size="small">귀가방법</TableCell> : null}
            </TableRow>
          </MyTableHead>
          <TableBody>
            {snapMap[selectedOption] &&
              snapMap[selectedOption].map((row, ridx) => {
                return (
                  <TableRow key={ridx}>
                    {fields.map((col, cidx) => {
                      if (col.visible) {
                        if (col.field === 'indexing') {
                          return <TableCell size="small">{ridx + 1}</TableCell>
                        }
                        if (selectedOption === 'waits') {
                          if (col.field === 'name') {
                            return (
                              <TableCell size="small">
                                {row[col.field]} ({ridx + 1})
                              </TableCell>
                            )
                          } else {
                            return <TableCell size="small">{row[col.field]}</TableCell>
                          }
                        } else {
                          return <TableCell size="small">{row[col.field]}</TableCell>
                        }
                      }
                    })}
					          {/* {selectedOption === 'current' ? <TableCell size="small">{row.offCodeName}</TableCell> : null} */}
                    {
                      selectedOption === 'current' ? (
                        <TableCell size='small'>
                          <Typography variant='body2'>
                            {row.offCodeName}
                          </Typography>
                        </TableCell>
                        
                      ) : null
                    }
                  </TableRow>
                )
              })}
          </TableBody>
        </MUITable>
        {snapMap[selectedOption] && snapMap[selectedOption].length === 0 ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Typography fullWidth align={'center'}>
              데이터가 없습니다.
            </Typography>
          </div>
        ) : null}
      </Fragment>
    )
  }

  // History Tab
  const History = () => {
    const fields = [
      { field: 'id', placeholder: '', type: 'text', value: -1, visible: false, canSrch: false, selList: [] },
      { field: 'regTime', placeholder: '일시', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
      { field: 'name', placeholder: '이름', type: 'text', value: '', visible: true, canSrch: false, selList: [] },
      { field: 'schoolId', placeholder: '학교명', type: 'auto', value: '', visible: false, canSrch: true, selList: [] },
      { field: 'grade', placeholder: '학년', type: 'number', value: '', visible: true, canSrch: true, selList: [] },
      { field: 'className', placeholder: '반', type: 'text', value: '', visible: true, canSrch: true, selList: [] },
      { field: 'classNum', placeholder: '번호', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
      { field: 'gdnPhone', placeholder: '보호자 전화 번호', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
      { field: 'statName', placeholder: '상태', type: 'number', value: '', visible: true, canSrch: false, selList: [] },
      { field: 'remark', placeholder: '비고', type: 'text', value: '', visible: false, canSrch: false, selList: [] },
    ]

    const [studentList, set_studentList] = React.useState([])

    const fetchHistory = async () => {
      const url = `/regi/history/lecture/${record.id}`
      const resp = await WebService.get(url)

      if (resp.repCode === 'ack') {
        const repMessage = JSON.parse(resp.repMessage)
        const report = JSON.parse(repMessage.report)
        return report
      } else {
        openSnackbar(resp.repMessage)
      }
    }

    const onLoadHistory = async () => {
      const report = await fetchHistory()
      const history = report.history

      const students = report.students
      students.forEach((r, idx) => {
        const statCode = history[idx].statCode
        printVariable('statCode', statCode)
        // 상태
        let codeName = findCode(codes, 'SA12', statCode)?.name
        r.statName = codeName

        // 내역 저장 일시
        r.regTime = history[idx].regTime
        printVariable('regTime', r.regTime)
      })

      set_studentList(students)
    }

    useEffect(() => {
      onLoadHistory()
    }, [])

    return (
      <MUITable>
        <MyTableHead>
          <TableRow>
            {fields.map((col, index) => {
              if (col.visible) {
                return (
                  <TableCell size="small" key={index} >
                    {col.placeholder}
                  </TableCell>
                )
              }
            })}
          </TableRow>
        </MyTableHead>
        <TableBody>
          {studentList.map((row, index) => {
            return (
              <TableRow key={index}>
                {fields.map((col, index) => {
                  if (col.visible) {
                    return <TableCell size="small">{row[col.field]}</TableCell>
                  }
                })}
              </TableRow>
            )
          })}
        </TableBody>
      </MUITable>
    )
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Main JSX
  return (
    <Fragment>
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Box className={'center'}>
            <Typography variant="h5" sx={{ fontWeight: 'bold' }} align="center">
              {record.title}
            </Typography>
            <Typography variant="h5" sx={{ margin: 1 }}>
              {' '}
              수강신청 명단
            </Typography>
          </Box>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent sx={{ minHeight: '10em' }}>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={tabValue}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, backgroundColor: '#fff' }}>
                <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                  <Tab
                    value="1"
                    label={
                      <Box sx={{ fontSize: '1em' }}>
                        <Select
                          value={selectedOption}
                          variant="standard"
                          size={'small'}
                          onChange={handleSelectChange}
                          disableUnderline
                          sx={{ color: 'inherit', fontSize: 'inherit' }}
                        >
                          <MenuItem value="current">현재 명단</MenuItem>
                          <MenuItem value="LT01">모집마감 명단</MenuItem>
                          {/*<MenuItem value='LX02'>수강탈락 명단</MenuItem> */}
                          <MenuItem value="LT02">수강선발 명단</MenuItem>
                          <MenuItem value="waits">대기자 명단</MenuItem>
                          <MenuItem value="LX03">미등록 명단</MenuItem>
                          <MenuItem value="LT03">등록완료 명단</MenuItem>
                          <MenuItem value="LT04">출석부생성 명단</MenuItem>
                        </Select>
                      </Box>
                    }
                  />
                  <Tab label="전체내역" value="2" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ minHeight: '60vh' }}>
                <NameList />
              </TabPanel>
              <TabPanel value="2" sx={{ minHeight: '60vh' }}>
                <History />
              </TabPanel>
            </TabContext>
          </Box>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button variant="outlined" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>

      {renderSnackbar()}
      {renderIndicator()}
    </Fragment>
  )
}

export default TeacherRegiPartName
